import React from 'react';
import styled from 'styled-components';
import Portal from './Portal';
import { Loader, loaderSizes } from './Loader';
import PropTypes from 'prop-types';

const loaderSize = 'lg';
const LoadingOverlay = ({ children }) => (
  <Portal>
    <LoadingWrapper>
      <Loader
        size={loaderSize}
        css={`
          left: calc(50% - ${loaderSizes[loaderSize]} / 2);
          top: calc(50% - ${loaderSizes[loaderSize]} / 2);
        `}
        id="loader"
        aria-label="loading"
        data-testid="loading-spinner"
      />
      {children}
    </LoadingWrapper>
  </Portal>
);

const LoadingWrapper = styled.div`
  background: ${({ theme }) => theme.darkGray};
  opacity: 0.8;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* The class .fixed-bottom has z-index 1030.
     Increasing the z-index of LoadingWrapper to prevent the .fixed-bottom elements to be shown. */
  z-index: 1031;
`;

LoadingOverlay.propTypes = {
  children: PropTypes.any,
};

export default LoadingOverlay;
